import { AxiosResponse } from 'axios';
import { axiosInstance } from '../../client';

export function getDocuments(page = 1, pageSize = 10, search = "", includeDeleted = false) {
  return axiosInstance.get(`Documents`, {
    params: { page, pageSize, search, includeDeleted },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getDocumentsAll(page?: number, pageSize?: number, search = "", includeDeleted = false) {
  return axiosInstance.get(`Documents`, {
    params: { page, pageSize, search, includeDeleted },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function createDocument(name: string, multiple: boolean, perPlant: boolean): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`Documents`, {
    name,
    multiple,
    perPlant
  }, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateDocument(
  id: number,
  data: { name: string; multiple: boolean; perPlant: boolean }
): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Documents/${id}`, data, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}

export function deleteDocument(id: number): Promise<AxiosResponse<void>> {
  return axiosInstance.delete<void>(`Documents/${id}`, {
    headers: { Accept: "application/json" },
  });
}
